<div
   class="leaderboard-block"
   *ngIf="currentPractice()">
   <h4>{{ title() }}</h4>
   <div class="leader-type">{{ isRegional() ? "* Regional" : "* Vetcor" }}</div>
   <small>
      You are currently ranked
      <b>{{ currentPractice().stats[rankField()] }}{{ currentPractice().stats[rankField()] | ordinal }}</b>
      within {{ isRegional() ? "your region" : "Vetcor" }}
   </small>
   <div class="leaderboard-table">
      <div class="leaderboard-column-headers">
         <div class="title c1">Rank</div>
         <div class="hospital-name c2">Name</div>
         <div class="subtext c3">COS</div>
         <div class="subtext c4">HM</div>

         <div class="title c5">@if (!!showLinks()) { Links Sent }</div>
      </div>
      <div
         class="leaderboard-card"
         [style]="{ maxHeight: maxHeight() ? maxHeight() : null }">
         @for (item of sortedPractices(); let i = $index; track item.practiceSKey) {
         <div class="leaderboard-inner-card">
            <div class="leaderboard-row">
               <div class="rank-cell c1">
                  <div
                     class="rank-box"
                     [ngClass]="{ 'green-rank': i < 5, 'gray-rank': i >= 5 }">
                     <img
                        *ngIf="i === 0"
                        src="assets/leaderboard/firstPlaceIcon.png"
                        alt="First Place" />
                     <img
                        *ngIf="i === 1"
                        src="assets/leaderboard/secondPlaceIcon.png"
                        alt="Second Place" />
                     <img
                        *ngIf="i === 2"
                        src="assets/leaderboard/thirdPlaceIcon.png"
                        alt="Third Place" />
                     {{ i + 1 }}
                     <sup>{{ i + 1 | ordinal }}</sup>
                  </div>
               </div>
               <div class="hospital-name c2">{{ item.friendlyName }}</div>
               <div class="subtext c3">{{ item.cos?.firstName }} {{ item.cos?.lastName }}</div>
               <div class="subtext c4">{{ item.hmFirstName }} {{ item.hmLastName }}</div>
               <div class="subtext c5">@if (!!showLinks()) { {{ item.stats.totalLinksSent }} }</div>
            </div>
         </div>
         }
      </div>
   </div>
</div>
